import { useState } from 'react'
import type { ShippingMethod } from '../utils/shipping'

export type PaymentMethod = 'ideal' | 'card' | 'klarna' | 'paypal'

export type CheckoutFields = {
  email: string
  firstName: string
  lastName: string
  address: string
  postcode: string
  city: string
}

type Errors = Partial<Record<keyof CheckoutFields, string>>

const initial: CheckoutFields = { email: '', firstName: '', lastName: '', address: '', postcode: '', city: '' }

export function useCheckoutForm() {
  const [fields, setFields] = useState<CheckoutFields>(initial)
  const [errors, setErrors] = useState<Errors>({})
  const [shipping, setShipping] = useState<ShippingMethod>('standaard')
  const [payment, setPayment] = useState<PaymentMethod>('ideal')

  const update = (key: keyof CheckoutFields, value: string) => {
    setFields((f) => ({ ...f, [key]: value }))
    if (errors[key]) setErrors((e) => ({ ...e, [key]: undefined }))
  }

  const validate = (): boolean => {
    const e: Errors = {}
    if (!/^\S+@\S+\.\S+$/.test(fields.email)) e.email = 'Vul een geldig e-mailadres in'
    if (!fields.firstName.trim()) e.firstName = 'Vul je voornaam in'
    if (!fields.lastName.trim()) e.lastName = 'Vul je achternaam in'
    if (!/\d/.test(fields.address)) e.address = 'Vul straat en huisnummer in'
    if (!/^\d{4}\s?[a-zA-Z]{2}$/.test(fields.postcode.trim())) e.postcode = 'Bijv. 1012 AB'
    if (!fields.city.trim()) e.city = 'Vul je woonplaats in'
    setErrors(e)
    if (Object.keys(e).length) {
      document.getElementById(`co-${Object.keys(e)[0]}`)?.focus()
      return false
    }
    return true
  }

  return { fields, errors, update, validate, shipping, setShipping, payment, setPayment }
}
